export const DeeplinkingProvider = {
  NoviBet: 'NOVI_BET',
  Yeet: 'YEET',
} as const;

export type DeeplinkingProvider =
  (typeof DeeplinkingProvider)[keyof typeof DeeplinkingProvider];

export const BETSLIP_PROVIDERS = new Set<DeeplinkingProvider>([
  DeeplinkingProvider.NoviBet,
  DeeplinkingProvider.Yeet,
]);

export const YeetBetType = {
  Regular: 'SPLASH_REGULAR_BET',
  BetBuilder: 'SPLASH_BETBUILDER_BET',
} as const;

export type YeetBetType = (typeof YeetBetType)[keyof typeof YeetBetType];
